/**
 * @file: buildQuoteSnapshot.ts
 *
 * Build the quote snapshot persisted alongside a reply, from the message
 * being quoted.
 */

import { ChatMsg, ChatQuoteSnapshot } from '@euler/model/chat';

export function buildQuoteSnapshot(msg: ChatMsg): ChatQuoteSnapshot {
  const { payload } = msg;
  let preview =
    payload.type === 'text'
      ? payload.text
      : payload.type === 'markdown'
      ? payload.markdown
      : `[${msg.payloadType}]`;
  if (preview.length > 120) preview = preview.slice(0, 119) + '…';
  return {
    author: {
      type: msg.authorType,
      role: msg.authorRole ?? null,
      id: msg.authorId,
      name: msg.authorName ?? '',
      avatar: msg.authorAvatar ?? undefined,
      appId: '',
      appScope: '',
    },
    payloadType: msg.payloadType,
    preview,
    payload: msg.payload,
    createdAt: msg.createdAt,
  };
}
